






























































































































import { Component, Vue } from "vue-property-decorator";
import ProviderMarkup from "@/store/entities/flight/providerMarkup";
import Currency from "@/store/entities/currency";
import MetaSearchAgency from "@/store/entities/metaSearchAgency";
import FlightProvider from "@/store/entities/flight/flightProvider";

@Component({})
export default class AddProviderMarkupModal extends Vue {
  dialog: boolean = true;
  providerMarkup: ProviderMarkup = new ProviderMarkup();
  providerMarkups: ProviderMarkup[] = [];
  currencies: Currency[] = [];
  currency: Currency = new Currency();
  airportInput: string = '';

  isEdit: boolean = false;
  metaSearchAgencies: MetaSearchAgency[] = [];
  metaSearchAgency: MetaSearchAgency = new MetaSearchAgency();
  flightProviders: FlightProvider[] = [];
  flightProvider: FlightProvider = new FlightProvider();

  handleAirportInput(value: string): void {
    // Sadece büyük harf ve - karakterine izin ver
    value = value.toUpperCase().replace(/[^A-Z-]/g, '');
    
    if (value.length === 3) {
      value = value + '-';
    } else if (value.length === 4 && !value.includes('-')) {
      value = value.slice(0, 3) + '-' + value.slice(3);
    }
    
    this.airportInput = value;
    
    // fromAirportId ve toAirportId'yi güncelle
    const [from, to] = value.split('-');
    this.providerMarkup.fromAirportId = from || '';
    this.providerMarkup.toAirportId = to || '';
  }

  async created(): Promise<void> {
    await this.getFlightProviders();
    await this.getCurrencies();
    await this.getProviderMarkups();
    await this.getMetaSearchAgencies();

    this.providerMarkup = this.$store.state.webServiceMarkup.editAuxiliaryMarkup;
  
    if (this.providerMarkup == null) {
      this.isEdit = false;
      this.providerMarkup = new ProviderMarkup();
    } else {
      this.isEdit = true;
      // Para birimi ayarı
      const currency = this.currencies.find(x => x.id === this.providerMarkup.currencyId);
      if (currency) {
        this.currency = currency;
        this.providerMarkup.currencyId = currency.id;
      }
      
      // Web servis (metaSearchAgency) ayarı
      const metaSearchAgency = this.metaSearchAgencies.find(x => x.id === this.providerMarkup.metaSearchAgencyId);
      if (metaSearchAgency) {
        this.metaSearchAgency = metaSearchAgency;
      }
      
      // Provider ayarı
      const flightProvider = this.flightProviders.find(x => x.id === this.providerMarkup.companyId);
      if (flightProvider) {
        this.flightProvider = flightProvider;
      }
      
      // Havalimanı input'unu mevcut değerlerle doldur
      if (this.providerMarkup.fromAirportId || this.providerMarkup.toAirportId) {
        this.airportInput = `${this.providerMarkup.fromAirportId || ''}-${this.providerMarkup.toAirportId || ''}`;
      }
    }
  }

  async saveProviderMarkup(): Promise<void> {
    if (this.flightProvider && this.metaSearchAgency) {
      this.providerMarkup.companyId = this.flightProvider.id;
      this.providerMarkup.metaSearchAgencyId = this.metaSearchAgency.id;

      if (!this.isEdit) {
        const currencyId = this.providerMarkup.currencyId && typeof this.providerMarkup.currencyId === 'object' ? this.providerMarkup.currencyId.id : this.providerMarkup.currencyId;
        const currency = this.currencies.find(x => x.id === currencyId);
        if (currency) {
          this.providerMarkup.currencyId = currency.id;
        }
        await this.$store.dispatch({
          type: "providerMarkup/addProviderMarkup",
          data: this.providerMarkup,
        });
        Vue.$toast.success("Kayıt Eklendi");
      } else {
        const currency = this.currencies.find(x => x.id === this.providerMarkup.currencyId);
        if (currency) {
          this.currency = currency;
        }
        await this.$store.dispatch({
          type: "providerMarkup/saveProviderMarkup",
          data: this.providerMarkup,
        });
        Vue.$toast.success("Kayıt Güncellendi");
      }
      this.dialog = false;
      this.$emit('closed');
    }
  }

  async getFlightProviders(): Promise<void> {
    await this.$store.dispatch({
      type: "flightProvider/getFlightProviders",
    });
    this.flightProviders = this.$store.state.flightProvider.list;
  }

  async getCurrencies(): Promise<void> {
    await this.$store.dispatch({
      type: "currency/getCurrencies",
    });
    this.currencies = this.$store.state.currency.list;
  }

  async getMetaSearchAgencies(): Promise<void> {
    await this.$store.dispatch({
      type: "metaSearchAgency/getMetaSearchAgencies",
    });
    this.metaSearchAgencies = this.$store.state.metaSearchAgency.list;
  }

  async getProviderMarkups(): Promise<void> {
    await this.$store.dispatch({
      type: "providerMarkup/getProviderMarkups",
    });
    this.providerMarkups = this.$store.state.providerMarkup.list;
  }
  
  closeDialog() {
    this.$emit("closed");
  }
}
